export const LOCATION_SUGGESTIONS = [
  'Hybrid · Austin',
  'Hybrid · Boston',
  'Hybrid · Chicago',
  'Hybrid · LA',
  'Hybrid · London',
  'Hybrid · NYC',
  'Hybrid · Seattle',
  'Hybrid · SF',
  'Remote · Americas',
  'Remote · North America',
  'Remote · US',
] as const;

export type LocationSuggestion = (typeof LOCATION_SUGGESTIONS)[number];
